/**
 * @file  popover浮层组件
 * @author liudy
 */

import React, { Component } from 'react';
import { components } from 'common';
const { If } = components;

export interface IProps {
    active?: boolean;
    onClick?: () => void;
    isHide?: boolean;
}

export default class MenuItem extends Component<IProps, {}> {
    constructor(props: IProps) {
        super(props);
    }

    public render() {
        const { active, children, isHide } = this.props;
        const activeCls = !!active ? 'active' : '';
        return (
            <If condition={!isHide}>
                <li className={`menu-item ${activeCls}`} onClick={this.props.onClick}>
                    {children}
                </li>
            </If>
        );
    }
}
